<form nz-form [formGroup]="purchaseRequestSearchForm">
    <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

        <!-- Filter Items -->

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['Timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            [nzLg]="4" [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
                    <nz-select formControlName="Timeframe" class="filters" id="Timeframe" nzPlaceHolder="Timeframe"
                        nzShowSearch style="width: 100%;">
                        @for(opt of loopback; track $index) {
                        <nz-option [nzLabel]="'Last ' + opt.label" [nzValue]="opt.val"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Status'">
                    <nz-select formControlName="status" class="filters" id="status" nzPlaceHolder="Status" nzShowSearch
                        nzAllowClear style="width: 100%;">
                        @for(opt of purchaseRequestStatusList; track $index){
                        <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['consumer']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Participant Name'">
                    <input placeholder="Participant Name" nz-input formControlName="consumer" id="consumer" />

                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['consumerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            [nzLg]="4" [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Participant PPL ID'">
                    <input placeholder="Participant PPL ID" nz-input formControlName="consumerPplId"
                        id="consumerPplId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['serviceCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            [nzLg]="6" [nzXl]="6" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Service Code'">
                    <nz-select formControlName="serviceCode" class="filters" id="payPeriod" nzPlaceHolder="Service Code"
                        nzShowSearch nzAllowClear style="width: 100%;">
                        @for(opt of purchaseRequestServiceCodes; track $index){
                        <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['pplPurchaseId']" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            [nzLg]="4" [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter PPL Purchase ID'">
                    <input placeholder="PPL Purchase ID" nz-input formControlName="pplPurchaseId"
                        id="pplPurchaseId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="purchaseRequestSearchForm.controls['crmNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            [nzLg]="4" [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter CRM Case Number'">
                    <input placeholder="CRM Case Number" nz-input formControlName="crmNumber"
                        id="crmNumber" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <!-- Search Button (Always aligned right) -->
        <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="text-align: right; margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <div style="display: flex; gap: 8px; align-items: center; flex-wrap: nowrap;">
                    <ppl-button label="Search" icon="fa fa-filter" [styleString]="'margin-top: -2px;'"
                        [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="search()"
                        *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'read']"></ppl-button>

                    @if(export) {
                    <ppl-button label="Export" icon="fa fa-download" [styleString]="'margin-top: -2px;'"
                        [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="exportToExcel()"
                        *authorize="[pageId, tabId, 'Export', 'section', 'read']"></ppl-button>
                    }
                </div>
            </nz-form-item>
        </div>

    </div>
    <div class="alert alert-danger" *ngIf="showErrors"><strong>Error:</strong> Please enter provider PPL id and consumer
        PPL id</div>
</form>